const menuButtonSelector = '.header__button';
const menuButtonToggleClass = 'header__button_opened';

const menuMobileSelector = '.header__mobile';
const menuMobileToggleClass = 'header__mobile_opened';

const menuMobileMenuItemWithChildrenSelector = '.header-mobile__item.menu-item-has-children';
const menuMobileMenuItemWithChildrenLinkSelector = '.header-mobile__link';
const menuMobileMenuItemWithChildrenToggleClass = 'header-mobile__item_opened';

const elements = {};

const Header = () => {
  elements.menuButton = document.querySelector(menuButtonSelector);
  elements.menuMobile = document.querySelector(menuMobileSelector);

  elements.menuButton.addEventListener('click', e => {
    elements.menuButton.classList.toggle(menuButtonToggleClass);
    elements.menuMobile.classList.toggle(menuMobileToggleClass);
  });

  elements.menuItemsWithChildren = document.querySelectorAll(menuMobileMenuItemWithChildrenSelector)

  elements.menuItemsWithChildren.forEach(item => {
    const link = item.querySelector(menuMobileMenuItemWithChildrenLinkSelector)

    link.addEventListener('click', e => {
      e.preventDefault()
      item.classList.toggle(menuMobileMenuItemWithChildrenToggleClass)
    })
  })
}

export default Header;
